<template>
	<div id="app">
		<div class="content-page" :class="(typeOrigin !== 'student') ? 'padding-minify' : ''" id="content-page"
			 ref="content_page">

			<!--NavigationBar-->
			<TheTopNavBar v-if="existValidationInformation"/> 
			<!--Content-->
			<router-view :class="isMobile ? 'mt-5' : ''" :style="  {minHeight:wh+'px'}" id="app_content" v-if="existValidationInformation"/>
			<ValidateInformation v-if="!existValidationInformation"/>

			<!--Footer-->
			<TheFooter style="margin-top:50px;" v-if="existValidationInformation && $route.path != '/eres-empleador' && $route.path != '/eres-capacitador'"/>
		</div>

		<WelcomeModal v-if="isLogin && !active && !welcomeModal && existValidationInformation && typeOrigin === 'student'"/>

<!--		Crear eventos para mostar las modales de empresa y capacitador-->
		<SuccessEnterprise v-if="typeOrigin === 'enterprise' && isLogin && welcomeModal"/>
		<SuccessTrainer v-if="typeOrigin === 'trainer' && isLogin && welcomeModal"/>
		<SuccessStudent v-if="typeOrigin === 'student' && isLogin && welcomeModal"/>
	</div>
</template>
<script>

import WelcomeModal from '@/components/#pages/#auth/activation/WelcomeModal'
import SuccessEnterprise from '@/components/#pages/#auth/activation/SuccessEnterprise'
import SuccessTrainer from '@/components/#pages/#auth/activation/SuccessTrainer'
import SuccessStudent from '@/components/#pages/#auth/activation/SuccessStudent'

import TheTopNavBar from "@/components/TheTopNavBar";
import TheFooter from "@/components/TheFooter";
import ValidateInformation from "./components/#pages/#auth/activation/ValidateInformation";

export default {
	name: 'App',
	components: {
		'TheTopNavBar': TheTopNavBar,
		'TheFooter': TheFooter,
		'ValidateInformation': ValidateInformation,
		'WelcomeModal': WelcomeModal,
		'SuccessEnterprise': SuccessEnterprise,
		'SuccessTrainer': SuccessTrainer,
		'SuccessStudent': SuccessStudent
	},
	data() {
		return {
			welcomeModal: false,
			notifications: 0,
			notificationsList: [],
			messages: false,
			wh: 0,
			existValidationInformation: true,
			  isMobile: this.$mobile(),
		}
	},
	computed: {
		navbar: function () {
			return this.$store.getters.navbarView
		},
		active: function () {
			return this.$store.getters.active
		},
		isLogin: function () {
			return this.$store.getters.isLoggedIn
		},
		typeOrigin: function () {
			return this.$store.getters.typeOrigin
		},
		notificationId: function () {
			return this.$store.getters.notificationId
		}
	},
	methods: {
		validationInformation() {
			this.api.get('profile/validate-information').then(({data}) => {
				if (data.request) {
					this.existValidationInformation = false
					this.$refs['content_page'].classList.remove('content-page', 'padding-minify')
				} else {
					this.existValidationInformation = true
				}

			}).catch(() => {
				console.log('error')
				this.$router.push('/');
			})
		},
		getCountNotification() {
			this.api.get('notification/unread').then(({data}) => {
				this.notifications = data.total > 10 ? 10 : data.data.length
				this.notificationsList = data.data
				this.bus.$emit('notify', this.notificationsList);
			});
		},
		getCountMessages() {
			this.api.get('message/unread').then(({data}) => {
				//TODO: Obtención de contador de mensajes
			})
		},
		pusher() {


			var channel = this.$pusher.subscribe('kllaar.' + this.notificationId);
			channel.bind('notification', (data) => {
				this.getCountNotification() //GetNotificationsCounter
				this.showNotification(data)
			})

			channel.bind('messages', (data) => {
				this.showNotification(data)
				this.$store.dispatch('notifyMessage', true)
			})

			channel.bind('activation', (data) => {
				this.welcomeModal = true
				localStorage.removeItem('active')
				this.showNotification(data)
			})
		},
		showNotification(data) {
			const process = (permission) => {
				if (permission === "granted") {
					if (!('Notification' in window)) {
						console.log("Este navegador no es compatible con las notificaciones de escritorio");
						return
					}

					Notification.requestPermission(permission => {
						let notification = new Notification(data.title, {
							body: data.text,
							icon: 'https://kllaar.com/img/logo-kllaar-notifications.jpg',
							image: 'https://kllaar.com/img/logo-kllaar-notifications.jpg'
						})
						// notification.onclick = () => {
						//window.open(data.url_redirect)
						// this.$router.push(data.url_redirect)
						// }
					})
				}
			}
			Notification.requestPermission((permission) => {
				process(permission)
			}).then((permission) => {
				process(permission)
			})

		},

		redSocialLogin() {
			let strings = window.location.search
			let params = new URLSearchParams(strings)
			let l = params.get('ltoail')

			if (l) {

				let i = atob(params.get('itoail'))
				let e = atob(params.get('etoail'))
				let r = atob(params.get('rtoail'))
				let p = atob(params.get('ptoail'))


				let data = new FormData();
				data.append('email', e)
				data.append('id_redsocial', r)
				data.append('id', i)

				this.api.post('auth/login/' + p, data).then(({data}) => {
					this.$store.dispatch('authenticate', data).then(() => {
						this.$router.push('/perfil');
					})
				}).catch(err => {
					console.log('error')
					this.$router.push('/');
				})

			}
		}
	},
	watch: {
		isLogin: function (val) {
			if (val) {
				location.reload()
			}
		},
	},
	mounted() {

		this.redSocialLogin()


		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.bus.$emit("resize-screen", {h: window.innerHeight, w: window.innerWidth})
			});
		})

		this.wh = window.innerHeight - 230;


		if (this.isLogin) {
			this.api.get("user/is-active").then(
				response => {
					this.$store.dispatch('emailValid', response.data)
				},
				error => {
				}
			)
		}
	},
	created: function () {
		this.$bus.$on("update_user_active", (data) => {
			if (data.user.id === this.$store.getters.getInfoUser.id){
				this.welcomeModal = true
				localStorage.removeItem('active')
				this.showNotification(data)
			}
		})



		if (this.isLogin) {
			this.pusher()
			this.getCountNotification()
			// this.getCountMessages()
			this.validationInformation()

		}

		const UNAUTHORIZED = 401;
		const MethodNotAllowed = 405;
		this.$http.interceptors.response.use(
			response => response,
			error => {
				const {status} = error.response;

				if (status === UNAUTHORIZED) {
					// this.$store.dispatch('logout')
					// // location.reload()
				} else if (status === MethodNotAllowed) {
					return false
				}

				return Promise.reject(error);
			}
		);
	},
}
</script>

<style>

@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css";

.shadow {
	-webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
	box-shadow: 0 0.5rem 1rem rgba(36, 64, 118, 0.15) !important;
}

.text-primary {
	color: #f9c332 !important;
}

.text-white-shadow {
	/*text-shadow: 2px 2px 1px #ffffff;*/
}

.text-kllaar {
	color: #004c9c !important;
}

a.text-kllaar:hover, a.text-primary:focus {
	color: #f9c332 !important;
}

a.text-kllaar:hover, a.text-primary:focus {
	color: #f9c332 !important;
}

.text-color-kllaar {
	color: #244076 !important;
}

.border-primary {
	border-color: #244076 !important;
}

.border-warning {
	border-color: #ed8f00 !important;
}

.bg-primary {
	background-color: #244076 !important;
}

.text-info {
	color: #f9c332 !important;
}

.font-kllaar {
	color: #244076;
}

.introjs-helperNumberLayer {
	background: #ed8c00 !important;
}

.introjs-bullets {
	display: none !important;
}

.introjs-tooltipbuttons {
	margin-top: 40px;
}

.introjs-overlay {
	background: linear-gradient(to right, #0F1B3A 0%, #0F1B3A 20%, #1B2F55 60%, #244076 100%) !important;
}

.carousel-control-prev-icon, .carousel-control-next-icon {
	width: 65px !important;
	height: 65px !important;
}

.carousel-control-prev, .carousel-control-next {
	width: 7% !important;
	/*margin-top:-200px;*/
}


.barra-bns {
	position: fixed;
	padding: 20px 20px 20px 0;
	bottom: 0;
	margin-right: 0;
	background: white !important;
	-webkit-box-shadow: 0 -11px 69px -31px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 0 -11px 69px -31px rgba(0, 0, 0, 0.75);
	box-shadow: 0 -11px 69px -31px rgba(0, 0, 0, 0.75);
	animation-duration: 0.25s !important;
}

#filter-data a.nav-link {
	color: #334e80;
	text-decoration: none;
	background-color: transparent;
}

#filter-data .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
	color: #334e80;
	background-color: transparent;
	border-color: #dee2e6 #dee2e6 #334e80;
}

.bg-clear-blue {
	background-color: #098aed;
	color: #fff;
}

.blue-kllaar-button {
	background-color: #001956;
	color: #fff;
	display: block;
}

.blue-kllaar-button:hover {
	background-color: #001956;
	color: #fff;
	text-decoration: underline;
}

label a.info-a {
	color: #2c4a87;
}

.btn-secondary.disabled, .btn-secondary:disabled.b-facebook {
	background-color: #fff;
	color: #4267b2;
}

.btn-secondary.disabled, .btn-secondary:disabled.b-linkedin {
	background-color: #FFF;
	color: #0E76A8;
}

.btn-secondary.disabled, .btn-secondary:disabled.b-google {
	background-color: #fff;
	color: #EA4335;
}


.swal-button:not([disabled]):hover {
	background-color: #244076;
}

.swal-button {
	background-color: #244076;
	color: #fff;
}
.swal-title{
	color: #999;
}
.swal-text{
	color: #999;
}

.btn-gray-light {
	color: #999;
}
.btn-gray-light.btn:hover {
	color: #212529;
	text-decoration: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue